export const UNO_URL = 'https://api.simulanis.io';
export const applicationId = "d8f07d6c-1b1c-4c3a-888a-33cfa5b8d1ec";
export const defaultLogo = "https://cdn.simulanis.io/sso/logos/default_simulanis.png";